import moment from 'moment-timezone';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import { twelveHourUserSetting, twelveHourZoneSpacedUserSetting } from '../../constants/timezone-format';
import { UserDateTimePropType } from '../../prop-types/user-date-time';
import Global from '../../store/global-selectors';

const normalizeTimeZoneSpacing = (timeFormat, spaceBetweenTimeAndZone) => {
  if (spaceBetweenTimeAndZone && timeFormat === twelveHourUserSetting) {
    return twelveHourZoneSpacedUserSetting;
  }
  return timeFormat;
};

export const UserDateTimezoneFormat = ({ dateTime, showTime = false, spaceBetweenTimeAndZone = false, timeFormat }) => {
  let userDateFormat = useSelector(Global.selectUserUserDateFormat);
  const localTimeFormat = useSelector(Global.selectUserUserTimeFormat);
  const timeZone = useSelector(Global.selectSellerTimeZoneIANA);

  const timeToUse = timeFormat || localTimeFormat;
  if (showTime) {
    userDateFormat += ` ${normalizeTimeZoneSpacing(timeToUse, spaceBetweenTimeAndZone)}`;
  }

  const t = moment(dateTime || moment().utc().format())
    .tz(timeZone)
    .format(userDateFormat);
  return t;
};

UserDateTimezoneFormat.propTypes = {
  dateTime: UserDateTimePropType,
  showTime: PropTypes.bool,
  spaceBetweenTimeAndZone: PropTypes.bool,
  timeFormat: PropTypes.string,
};
